export default {
    methods: {
        /**
         * @param {HTMLEvent} ev
         * @param {string} val
         * @return {string}
         */
        setFormatPhoneNumber(ev, val) {
            if (ev.keyCode === 8 && /^\(\d{3}$/.test(val)) {
                return ('' + val).replace(/\D/g, '');
            }
            let phoneNumberString = val;
            var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
            var cleanedPhoneNumberRegex = /^(\d{3})(\d{1,3})?(\d{1,4})?$/;
            var match = cleaned.match(cleanedPhoneNumberRegex);
            if (match) {
                return '(' + match[1] + ')' + (match[2] ? ' ' + match[2] : '') + (match[3] ? '-' + match[3] : '');
            }

            return val;
        }
    }
}